<template>
	<editor
		:show.sync="editorVisible"
		:data-model-name="editorDataModel"
		:fields="editorFields"
		:use-submit-event="true"
		@submit="onSubmit"
		:check-ever-edited="false"
		:max-info="{k:'total_price', v: maxPay}"
		:default-value="{total_price:maxPay}"
		v-if="editorVisible"
	>
		<template slot="info">
			<div class="col-6">
				<el-form-item label="客户">{{customerInfo.name}}</el-form-item>
			</div>
			<div class="col-6" v-if="payMethod=='balance'">
				<el-form-item label="余额">{{customerInfo.balance}}</el-form-item>
			</div>
			<div class="col-6" v-if="payMethod=='credits'">
				<el-form-item label="积分">{{customerInfo.credits}} / {{configs['Product.credit_use_ratio']}} = {{creditsAs}}</el-form-item>
			</div>
			<div class="col-6">
				<el-form-item label="待支付">{{totalPay}}</el-form-item>
			</div>
		</template>
	</editor>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
	data() {
		return {
			editorDataModel: "Cashflow",
			
		};
	},
	computed: {
		...mapState(["userPrivilegeMapping","configs"]),
		maxPay:{
			get: function() {
				let IHaveMoney = 0;
				if (this.payMethod=='credits') {
					IHaveMoney = this.creditsAs;
				} else {
					IHaveMoney = this.customerInfo.balance;
				}
				if (IHaveMoney > this.totalPay) {
					return this.totalPay;
				} else {
					return IHaveMoney;
				}
			},
		},
		creditsAs:{
			get: function() {
				if (!this.configs['Product.credit_use_ratio']) {
					return 0;
				}
				return Math.floor(this.customerInfo.credits / this.configs['Product.credit_use_ratio']);
			},
			
		},
		editorVisible: {
			get: function() {
				return this.show;
			},
			set: function(val) {
				this.$emit("update:show", val);
			}
		},
		editorFields:  {
			get: function() {
				
				const fields = [
					{
						name: "total_price",
						col: 6
					},
				];
				return fields
			},
			
		},
		
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		customerInfo: {
			type: Object,
			default: function() {
				return {}
			}
		},
		payMethod: {
			type: String,
			default: ''
		},
		totalPay: {
			type: Number,
			default: 0
		},
	},
	methods: {
		onSubmit(val) {
			if (this.payMethod=='balance') {
				val.pay_method = {
					index: 1,
					name: '余额'
				}
			} else {
				val.pay_method = {
					index: 60,
					name: '积分'
				}
			}
			this.$emit("submit", val);
			this.editorVisible = false;
		}
	}
};
</script>